import React, { useState } from 'react'
import classes from './CreditPage.module.css'
import { creditimage } from '../../assets/images'
import { StaticAlt } from '../../shared/utils/constants'
import { caretUp, plate, star } from '../../assets/icons'
import { Slider } from '@mui/material'
import { useGlobal } from '../../shared'
import CircularProgress from '@mui/material/CircularProgress'
import { baseURL, urls } from '../../shared/config'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
const CreditPage = () => {
  const tabs = ['Monthly', 'Yearly']
  const [selected, setSelected] = useState('Monthly')
  const [open, setOpen] = useState(false)
  const [sliderValue, setSliderValue] = useState(101)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const userData = JSON.parse(localStorage.getItem('userAttributes'))
  const userSchoolId = localStorage.getItem('userSchoolId')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const handleOpen = () => {
    setOpen(!open)
  }
  const {
    data: cardData,
    loading: cardLoading,
    error: cardError,
  } = useGlobal({
    userUrl: `${urls.CREDIT_PAGE_GET}`,
  })
  const filteredCards = Array.isArray(cardData)
    ? cardData.filter((card) => card.credit_time_period === selected.toLowerCase())
    : []

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue) // Update state when slider moves
  }
  const employeeId = userData?.sub

  if (cardLoading) {
    return (
      <div className={classes.backdrop}>
        <CircularProgress />
      </div>
    )
  }
  if (cardError) {
    console.error('Error Fetching Data', cardError)
    return <p>Error Fetching Data</p>
  }
  const activePlan = selectedPlan || {
    credit: sliderValue,
    count: sliderValue,
    price: sliderValue * 10,
  }
  const handleSubmit = async () => {
    const responseBody = {
      ...(selectedPlan?.credit_id && { credit_id: selectedPlan.credit_id }),
      employee_id: employeeId,
      school_id: parseInt(userSchoolId, 10),
      amount: parseFloat(
        (
          (activePlan.price || activePlan.credit_amount * activePlan.credit_total_number) * 1.18
        )?.toFixed(2),
      ),
      count: activePlan.credit || activePlan.credit_total_number,
      sgst: 9,
      cgst: 9,
    }
    // console.log('=====responseBody',responseBody)
    const response = await axios.post(`${baseURL}${urls.CREDIT_PAGE_BUY_POST}`, responseBody)
    if (response?.data?.status === 201) {
      setLoading(true)
      navigate(`/dashboard`)
    } else {
      console.error('Error Posting Data', response)
      toast.error('Error Buying Credits Please Try Later')
    }
  }

  return (
    <>
      {loading ? (
        <div className={classes.backdrop}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {' '}
          {/* <ToastContainer />{' '} */}
          <div className={classes.topwrapper}>
            <div className={classes.subwrapper}>
              <div className={classes.lhs}>
                <div className={classes.tabs}>
                  {tabs.map((tab, index) => (
                    <div
                      key={index}
                      className={selected === tab ? classes.selected : classes.notselected}
                      onClick={() => setSelected(tab)}
                    >
                      {tab}
                      {tab === 'Yearly' && <span className={classes.discount}> 10% Off </span>}
                    </div>
                  ))}
                </div>
                <div className={classes.billSection}>
                  <div className={classes.top}>
                    <div className={classes.subtop}>
                      <div className={classes.header}>
                        <img src={star} alt={StaticAlt} className={classes.starimg} />
                        <p className={classes.recommendtxt}>We recommend according to your needs</p>
                      </div>
                      <div className={classes.maintop}>
                        <div className={classes.mainlhs}>
                          <p className={classes.credittx}>
                            {activePlan.credit || activePlan.credit_total_number}
                          </p>
                          <p className={classes.subcredtxt}>Credits</p>
                        </div>
                        <button onClick={handleSubmit} className={classes.paynowbtn}>
                          Pay Now
                        </button>
                      </div>
                    </div>
                    <div className={classes.breakdown}>
                      <div className={classes.breaktop}>
                        <p className={classes.priceBreakdowntxt}>Price Breakdown</p>
                        <img
                          onClick={handleOpen}
                          src={caretUp}
                          style={{
                            cursor: 'pointer',
                          }}
                          className={open ? classes.open : classes.notopen}
                          alt=""
                        />
                      </div>
                      {open && (
                        <div className={classes.prices}>
                          <div className={classes.maintop}>
                            <div className={classes.countdiv}>
                              <p className={classes.count}>
                                License Count ({activePlan.count || activePlan.credit_total_number})
                              </p>
                            </div>
                            <p className={classes.proice}>
                              $
                              {activePlan.price ||
                                activePlan.credit_amount * activePlan.credit_total_number}
                            </p>
                          </div>
                          <div className={classes.maintop}>
                            <div className={classes.countdiv}>
                              <p className={classes.count}>SGST(9%)</p>
                            </div>
                            <p className={classes.proice}>
                              $
                              {(
                                (activePlan.price ||
                                  activePlan.credit_amount * activePlan.credit_total_number) * 0.09
                              )?.toFixed(2)}
                            </p>
                          </div>
                          <div className={classes.maintop}>
                            <div className={classes.countdiv}>
                              <p className={classes.count}>CGST(9%)</p>
                            </div>
                            <p className={classes.proice}>
                              $
                              {(
                                (activePlan.price ||
                                  activePlan.credit_amount * activePlan.credit_total_number) * 0.09
                              )?.toFixed(2)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={classes.pay}>
                      <p className={classes.payttxt}>Payable</p>
                      <p className={classes.totaltxt}>
                        {' '}
                        $
                        {(
                          (activePlan.price ||
                            activePlan.credit_amount * activePlan.credit_total_number) * 1.18
                        )?.toFixed(2)}{' '}
                        / {selected}
                      </p>
                    </div>
                  </div>
                </div>

                <hr className={classes.rule} />
                <div className={classes.billSection}>
                  <div className={classes.top}>
                    <div
                      // style={{
                      //   borderBottom: 'none',
                      // }}
                      className={classes.subtop}
                    >
                      <div className={classes.header}>
                        <img src={plate} alt={StaticAlt} className={classes.starimg} />
                        <p className={classes.recommendtxt}>Some Other Options We recommend</p>
                      </div>
                    </div>
                    <div className={classes.cards}>
                      {filteredCards.length > 0 ? (
                        filteredCards.map((card, index) => (
                          <div
                            key={index}
                            style={
                              index === filteredCards.length - 1 ? { borderRight: 'none' } : {}
                            }
                            className={classes.card}
                          >
                            <div className={classes.cardtop}>
                              <p className={classes.credittx}>{card.credit_total_number}</p>
                              <p className={classes.subcredtxt}>Credits</p>
                            </div>
                            <div className={classes.cardmiddle}>
                              <div className={classes.maintop}>
                                <p className={classes.licensetxt}>
                                  License Count ({card.credit_license})
                                </p>
                                <p className={classes.cardprice}>${card.credit_amount}</p>
                              </div>
                              <p className={classes.suvttx}>1 Credit = 1 License</p>
                            </div>
                            <button
                              onClick={() => {
                                setSelectedPlan(card)
                              }}
                              className={classes.selectbtn}
                            >
                              Select
                            </button>
                          </div>
                        ))
                      ) : (
                        <p>No data available for {selected}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className={classes.billSection}>
                  <div className={classes.top}>
                    <div
                      // style={{
                      //   borderBottom: 'none',
                      // }}
                      className={classes.subtop}
                    >
                      <div className={classes.header}>
                        <img src={plate} alt={StaticAlt} className={classes.starimg} />
                        <p className={classes.recommendtxt}>Custom Credits</p>
                      </div>
                      <div className={classes.maintop}>
                        <div className={classes.sublhs}>
                          <p className={classes.credittx}>{sliderValue}</p>
                          <div className={classes.assets}>
                            <p className={classes.licensetxt}>License Count ({sliderValue})</p>
                            <p className={classes.subcredtxt}>Credits</p>
                          </div>
                        </div>
                        <button
                          style={{
                            width: '146px',
                          }}
                          className={classes.paynowbtn}
                          onClick={() => setSelectedPlan(null)}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                    <div className={classes.slider}>
                      <Slider
                        value={sliderValue}
                        onChange={handleSliderChange}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        max={200}
                        sx={{
                          color: '#155DEE', // Active track color
                          '& .MuiSlider-thumb': {
                            backgroundColor: '#FFFFFF', // White thumb (circle)
                          },
                          '& .MuiSlider-thumb:hover': {
                            backgroundColor: '#FFFFFF', // Keep it white on hover
                          },

                          '& .MuiSlider-track': {
                            backgroundColor: '#155DEE', // Filled track color
                            height: 13, // Set height for track
                            borderRadius: 0, // No rounded edges
                          },
                          '& .MuiSlider-rail': {
                            backgroundColor: '#F2F4F7', // Remaining path track color
                            height: 13, // Set height for rail
                            borderRadius: 0, // No rounded edges
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.rhs}>
                <img src={creditimage} alt={StaticAlt} className={classes.image} />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default CreditPage
